import styled from 'styled-components';
import { beam } from '@styles/colors/themes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BlueButton } from '@pages/Products/components/OnBoardingModal/OnBoardingModal.styles';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

export const Container = styled.div`
  padding: 24px;
  width: 700px;
  max-height: 90vh;
  align-self: center;
  justify-self: center;
  display: flex;
  flex-direction: column;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 9px 26px #0000003d;
  border-radius: 8px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  grid-template-columns: minmax(min-content, 500px) 1fr;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Body = styled.div`
  overflow-x: hidden;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;

  thead {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 10;
  }

  th {
    text-align: left;
    background: #fff;
  }

  td {
    padding: 16px 0;
    color: #1a1b1c;
    font-size: 16px;
  }

  tr + tr {
    border-top: 1px solid #d0dae3;
  }
`;

export const User = styled.div`
  display: flex;
  align-items: center;
`;

export const Profile = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 16px;
`;

export const Menu = styled.img`
  cursor: pointer;
`;

export const Head = styled.div`
  background: #fafbfd;
  color: #758ca3;
  font-size: 12px;
`;
export const ProductsText = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: 500;
  font-size: 14px;
  /* identical to box height */
  align-items: center;
  text-align: right;
  justify-content: flex-start;
  cursor: pointer;

  /* beam-colors/beam-accent */
  color: #1371fe;
`;
export const Invite = styled.div`
  color: #1371fe;
`;

interface IInput {
  isLink?: boolean;
}

export const InputText = styled.input<IInput>`
  width: 100%;
  height: 42px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  color: ${({ isLink }) =>
    isLink ? beam.color.primaryBlue : beam.font.primary};
  text-decoration-line: ${({ isLink }) => (isLink ? 'underline' : 'unset')};
  transition: all 0.2s;
  font-size: 14px;

  ::placeholder {
    font-size: 14px;
    font-weight: 400;
    color: #8f95b2;
  }
`;
export const Line = styled.div`
  display: flex;
  align-items: center;
`;

export const Name = styled.div`
  color: #838a91;
  font-size: 14px;
`;
export const Role = styled.p`
  color: #1a1b1c;
  font-size: 14px;
  flex: 1;
  font-weight: 500;
  font-style: normal;
  white-space: nowrap;
`;
export const RoleNormal = styled(Role)`
  font-weight: 300;
`;

export const IconImg = styled.img`
  color: blue;
  width: 14px;
  height: 14px;
`;

export const Add = styled.div`
  color: #1371fe;
  font-size: 14px;
  text-align: right;
`;
export const Icon = styled(FontAwesomeIcon)`
  color: ${beam.font.primary};
  width: 11px;
  height: 14px;
`;
export const Manufacturer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ManufacturerRight = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
  width: 100%;
`;
export const Address = styled.div`
  color: #1a1b1c;
  font-size: 24px;
  margin-bottom: 12px;
`;
export const HeaderText = styled.div`
  font-weight: 500;
  font-size: 14px;

  margin-right: 12px;

  color: ${beam.font.primary};
`;
export const Header = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 16px;
`;
export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  width: 50%;
  max-width: 350px;
  margin-right: 16px;
`;

export const Search = styled.input`
  background: #ffffff;
  /* borders/light-border */
  border: 1px solid #d0dae3;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 14px;
  color: #787878;
  height: 36px;
  display: flex;
  align-items: center;
  flex: 1;
  padding-left: 31px;
  padding-right: 8px;
  -webkit-appearance: none;

  ::placeholder {
    color: #787878;
  }
`;

export const SearchImg = styled.img`
  position: absolute;
  left: 12px;
  z-index: 2;
`;
export const Image = styled.img`
  width: 155px;
  margin-top: 16px;
  margin-bottom: 12px;
  height: 100px;
  border-radius: 4px;
  object-fit: cover;
`;
export const WhiteButton = styled(BlueButton)`
  background: #ffffff;
  border: 1px solid ${beam.border.back};
  color: ${beam.font.primary};
  font-weight: 500;
  margin: 0;
`;
export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-left: -9px;
  align-items: center;
  margin-right: 24px;
`;

export const CheckCircle = styled.img`
  cursor: pointer;
  margin: 0;
  width: 18px;
  height: 18px;
`;

export const Label = styled.div`
  color: #1a1b1c;
  font-size: 14px;
`;

export const SvgImg = styled.img`
  width: 16px;
  margin: 0;
`;
export const UncheckCircle = styled(RadioButtonUncheckedIcon)`
  color: #d0dae3;
  width: 18px !important;
  height: 18px !important;
`;

export const GlobalHeader = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  margin-bottom: 8px;
  color: #3c546b;
`;
export const AssociateText = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  /* identical to box height */

  color: #8f95b2;
  margin-bottom: 24px;
`;
export const InputDiv = styled.div`
  /* Layout Properties */
  display: flex;
  flex-direction: column;
  margin-left: 16px;
  width: 100%;
  justify-content: start;
  align-items: start;
  & .react-date-picker {
    & .react-date-picker__wrapper {
      border: none;
      height: 100%;
      display: flex;
      justify-content: center;
    }
    & .react-calendar {
      width: 400px !important;
      display: table-caption;
    }
  }
`;
export const ImageManufacturer = styled.img`
  width: 155px;
  margin-top: 16px;
  margin-bottom: 12px;
  height: 100px;
  border-radius: 4px;
  object-fit: cover;
`;
export const Cancel = styled.button`
  height: 42px;
  background: #ffffff;
  border: 1px solid ${beam.border.back};
  color: ${beam.font.primary};
  font-weight: 500;
  font-size: 14px;
  border-radius: 8px;
  padding: 10px 16px;
  align-items: center;
  /* identical to box height */
  /* beam texts/default-black */
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Confirm = styled.button`
  background: #1371fe;
  height: 42px;
  font-weight: 500;
  font-size: 14px;
  /* neutral tones/default-white */
  color: #ffffff;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  :disabled {
    background-color: #edeff4;
    color: #c1c4d6;
  }
`;
export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
export const FileName = styled.div`
  width: 100%;
  height: 36px;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  color: ${beam.font.primary};
  background: #fff;
  align-items: center;
  justify-content: flex-start;
  padding-left: 10px;
  padding-right: 20px;
  border: 1px solid #e9edf1;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.161);

  :disabled {
    border: 1px solid #e9edf1;
    ::placeholder {
      color: ${beam.font.primary};
    }
  }
  ::placeholder {
    color: ${beam.font.label};
  }
`;
interface isActiveProps {
  isActive?: boolean;
  isDisabled?: boolean;
}
export const SelectFile = styled.div<isActiveProps>`
  display: flex;
  width: 90px;
  height: 42px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  color: #696f8c;
  background: #fff;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  box-sizing: border-box;

  margin-left: -90px;

  ::-webkit-file-upload-button {
    display: none;
  }

  transition: 0.2s;
  :hover {
    filter: brightness(0.9);
  }
`;
export const IconCloseAwesome = styled(FontAwesomeIcon)`
  position: absolute;
  background: white;
  width: 24px !important;
  padding: 1px 6px;
  right: 0px;
  cursor: pointer;
`;

export const Header2 = styled.div`
  display: flex;
  align-items: center;
  height: auto;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 24px;
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 18px;
  font-weight: 600;
  flex: 1;

  &.label {
    color: #474d66;
    font-size: 12px;
    font-weight: 500;
  }

  &.associate {
    font-weight: 500;
    font-size: 14px;
  }

  &.optional {
    font-size: 12px;
    font-weight: 500;
    color: #8f95b2;
  }

  &.description {
    font-size: 12px;
    font-weight: 400;
    color: #8f95b2;
  }
`;

export const Close = styled.div`
  cursor: pointer;
  align-self: flex-start;
`;

export const Close2 = styled.div`
  cursor: pointer;
  align-self: flex-start;
`;

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const DocOriginDiv = styled.div`
  display: flex;
  flex-direction: row;
`;

interface IDivider {
  height?: string;
  width?: string;
}

export const Divider = styled.div<IDivider>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;

export const TextArea = styled.textarea`
  display: flex;
  width: 100%;
  height: 80px;
  border-radius: 8px;
  border: 1px solid #d8dae5;
  padding: 10px 16px;
  font-size: 14px;

  ::placeholder {
    font-size: 14px;
    font-weight: 400;
    color: #8f95b2;
  }
`;
